// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'move-right-solid';

export const Component = () => (
  <path d='M4.343 3.044v18.912c0 .025-.02.044-.045.044H2.546a.045.045 0 0 1-.046-.044V3.044c0-.025.02-.044.046-.044h1.752c.025 0 .045.02.045.044Zm11.901 13.3 3.038-2.934H7.387c-.567 0-.932-.35-.932-.896 0-.566.353-.94.932-.94H19.28l-3.05-2.935c-.24-.133-.335-.384-.335-.686 0-.545.364-.896.931-.896.25 0 .477.094.656.266l4.74 4.515.089.12c.126.242.188.4.188.556 0 .138-.04.228-.188.512l-.09.12-4.741 4.516a.93.93 0 0 1-.654.265c-.567 0-.931-.35-.931-.896 0-.287.11-.535.348-.687Z' />
);

export const viewBox = '0 0 25 25';
